import { Box, CircularProgress, Typography } from "@mui/material";
import type { ReactNode } from "react";

export function FullPageSpinner() {
  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export function Notice({ children }: { children: ReactNode }) {
  return (
    <Box sx={{ px: 2, py: 3, textAlign: "center" }}>
      <Typography variant="body2" color="text.secondary">
        {children}
      </Typography>
    </Box>
  );
}
